<template>
  <div class="pageDiv">
    <v-card class="main-card">
      <v-card-text  class="info-heading" v-if="tournament !== null">
        <div class="text">
          <v-card-text class="title1"  v-if="tournament !== null">
            <v-card-title v-if="tournament.sponsorName !== ''" class="label18">
              {{tournament.sponsorName}}
            </v-card-title>
            <br><br>
          </v-card-text>
          <div class="title2">
          <span class="label18">
            <span class="label16">{{totalParticipants}} Guests Registered</span>
            <span v-if="tournament.limitSize>0"> (Limit {{tournament.limitSize}})
            </span>
          </span>
          </div>

          <b>Date: </b> {{printDate(tournament.scheduleDate)}}<br>
          <b>Time: </b> {{printTime(tournament.scheduleDate)}}<br>
          <b>Deadline: </b> {{printDateTime(tournament.registrationDeadline)}}<br>
          <b>Location: </b> {{course.location}}<br>
          <b>Website: </b><a @click="goTo(tournament)">{{course.website}}</a><br>
          <span v-if="tournament.hole19!==null && tournament.hole19!==''">
              <b>19th Hole: </b> {{tournament.hole19}}
          </span>
          <br>
          <div v-if="tournament.status === 'REGISTER'">
            <a class="label16" @click="registerBanquet()">
              <span class="label18">Click here to register</span>
            </a>
          </div>

          <br><br>
        </div>

        <div class="image" v-if="hasSponsor()">
          <v-card-text>
            <span class="label16">Tournament Sponsored by:</span>
          </v-card-text>
          <img class="sponsor-img" :src="$AuthSvc.getBanquetFlyerUrl()" >
        </div>

      </v-card-text>
      </v-card-text>

      <v-card-text v-if="tournament === null">
        <v-card-title style="padding-bottom:0">
          <span class="page-title">Registration List</span>
        </v-card-title>
         No tournament registration at this time.
      </v-card-text>

      <v-card-text v-if="tournament !== null && tournament.status==='REGISTER_COMPLETED'">
        <span class="label16" style="color:darkred">
          Registration is now CLOSED. Please contact our President or Tournament Coordinator if you have any further questions. See everyone at the tournament!
        </span>
      </v-card-text>


      <v-card-text class="member-table-card" v-if="registerBanquets !== null && registerBanquets.length > 1">
        <v-card-title>
          Select course for registration list:
        </v-card-title>
        <v-card-text class="member-table-card">
          <div  v-for="tn in registerBanquets" :key="tn.tournament.tournamentId" style="padding:5px 10px; width:100%;text-align:left;">
            <div class="select-btn" @click="selectTournament(tn)">
              <span style="display:inline-block;padding-top:7px;;text-align:left;margin-right:20px">
                {{printDateTime(tn.tournament.scheduleDate)}}
              </span>
              <span style="display:inline-block;padding-top:7px;text-align:left;">
                {{tn.course.name}}
              </span>
              <span v-if="!$AuthSvc.isMobile()"> ({{$AuthSvc.printFormat(tn.tournament.formatType)}}) </span>
            </div>
          </div>
        </v-card-text>
      </v-card-text>

      <v-card-text class="member-table-card" v-if="members.length>0">
         <v-simple-table class="simple-table">
          <tr>
            <th width="10px">#</th>
            <th width="200px">Name</th>
            <th>Guest(s)</th>
            <th width="10px">Owe</th>
          </tr>
          <tr v-for="(n, index) in members" :key="n.userid">
            <td>{{index+1}}</td>
            <td>
              {{n.firstName}} {{n.middleName!==null && n.middleName!==''?n.middleName.charAt(0):''}} {{n.lastName}}
              <v-img class="member-logo" v-if="n.memberId !== null" src="../../assets/img/dfwvga-logo-mini.png">
              </v-img>
            </td>
            <td>
              {{getGuestList(n.specialRequest)}}
            </td>
            <td :class="{standby: n.paymentType==='StandBy', stillOwe: n.owe > 0}"><span class="dollar" v-if="n.owe>0">$</span>{{n.owe===0?'PAID':n.owe}}</td>
          </tr>
        </v-simple-table>
      </v-card-text>

    </v-card>
  </div>
</template>

<script>
import moment from 'moment';

  export default {
    name: "login",
    data: () => ({
      sponsor: null,
      selectCourse: null,
      tournament: null,
      scheduleDate: '',
      scheduleTime: '',
      course: null,
      registerBanquets: [],
      members: [],
      totalParticipants: 0
    }),
    mounted: function() {
      var _this = this;

      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get('id')
      if (id !== null && id !== '') {
        _this.$CommandSvc.get(_this, '/public/tournaments/' + id, function(data) {
          if (data.length !== null) {
            _this.tournament = data;
            _this.loadPlayerList(_this.tournament);
          }
        });
      } else {
        _this.$CommandSvc.get(_this, '/public/tournaments/status/REGISTRATION_LIST', function(data) {
          _this.registerBanquets = data;
          if (data.length === 1) {
            _this.course = data[0].course;
            _this.tournament = data[0].tournament;
            _this.tournament.course = _this.course;
            _this.scheduleDate = data[0].scheduleDate;
            _this.scheduleTime = data[0].scheduleTime;
            window.sessionStorage.setItem('selectTournament', JSON.stringify(_this.tournament));
            _this.loadPlayerList(_this.tournament);
          }

          if (_this.tournaments.length > 1) {
            _this.tournaments.sort((a, b) => {
              if ( moment(a.tournament.scheduleDate).isAfter(b.tournament.scheduleDate) ) {
                return 1;
              }
              else {
                return -1;
              }
            });
          }

        });
      }

      _this.$CommandSvc.get(_this, '/public/config/current-sponsor',
          function (data) {
             if (data !== '') {
                _this.sponsor = data;
             }
          },
          function (error) {
              console.log('ERROR: ' + error);
          });

    },
    methods: {
      getProximity(proximity) {
        return (proximity===null || proximity==="null"?"":proximity.charAt(0));
      },
      hasSponsor() {
        return (this.sponsor !== null && this.sponsor.showSponsor === 'Y');
      },
      isBanquet() {
        if (this.tournament !== null) {
          return this.tournament.formatType === 'BANQUET';
        }

        return false;
      },
      hasRegistered() {
        return this.members.length > 0 ;
      },
      getHcp(hcp) {
        if (hcp < 60) {
          return Number(hcp).toFixed(1);
        }
        else {
          return "N/A";
        }
      },
      getGuestList(specialRequest) {
        if (specialRequest !== null) {
          return specialRequest.replaceAll(",", "\n");
        }
        return "";
      },
      registerBanquet() {
        window.location.href = "/registration-banquet?id=" + this.tournament.tournamentId;
      },
      printDate(date) {
        return moment(date).format('dddd MMMM DD YYYY');
      },
      printTime(date) {
        return moment(date).format('hh:mm A');
      },
      printDateTime(date) {
        return moment(date).format('MMMM DD hh:mm A');
      },
      birdie(n) {
        if (n.birdieHunt === 'Yes') {
          return '$10';
        }
        else {
          return '$0';
        }
      },
      selectTournament(tn) {
        this.course=tn.course;
        this.tournament = tn;
        window.location.href = "/list-registration?id=" + tn.tournament.tournamentId;
      },
      loadPlayerList(tournament) {
        var _this = this;

        _this.$CommandSvc.get(_this, '/public/courses/' + tournament.courseId, function(data) {
          _this.course = data;
        });

        _this.$CommandSvc.get(_this, '/public/tournaments/' + tournament.tournamentId + '/registrations', function(data) {
          _this.members = data;
          _this.totalParticipants = 0;
          for(let i=0; i < _this.members.length; i++) {
            _this.totalParticipants++;
            _this.totalParticipants += _this.members[i].lateFee;
          }
        });
      }
    }
  }

</script>

<style scoped>

  .dollar {
    font-family: Copperplate !important;
  }

  @media (min-width: 768px) {
      .simple-table {
        width: 1024;
      }

      .info-heading .title1, .info-heading .title2 {
          display: inline-block;
          width: 100% !important;
      }

      .info-heading .text {
          display: inline-block;
          width: 48% !important;
          vertical-align: top;
          padding: 10px;
          vertical-align: top;
      }

      .info-heading .image {
          display: inline-block;
          width: 45% !important;
          padding: 5px;
          vertical-align: top;
      }

      .image {
        margin-top: 0px;
      }
  }

  .member-table-card {
      overflow-y: scroll;
      height: 100%;
  }

  .course-name {
    width: 100%;
  }

  .select-btn {
    margin-right: 20px;
    text-align: left;
    background-color: #1867c0;
    width:100%;
    border-radius: 7px;
    padding: 10px;
    color: white;
  }

  .select-btn:hover {
    cursor: pointer;
  }

  .member-logo {
    display: inline-block;
    height: 16px;
    width: 16px;
    border-radius: 45px;
    margin-left: 10px;
  }

  .standby {
    background-color: lightgrey;
  }

  .stillOwe {
    background-color: red
  }

  .birdieHunt {
    background-color: lightgreen !important;
  }

  td {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
</style>